import PropTypes from 'prop-types';
import React, { Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { connect } from 'react-redux';
import wrapDisplayName from 'recompose/wrapDisplayName';
import { omit, flowRight } from 'lodash';
import { showJoinCommunityPopup } from '../services/join-community-popup-service';
import { getCurrentUser, isBlocked, isOwner, isPrivate } from '../selectors/current-user-selectors';
import { isMemberAreaActive } from '../selectors/member-area-selectors';
import { isSite } from '../selectors/view-mode-selectors';

const NAME = 'withAuth';

export default function withAuth(WrappedComponent) {
  class WithAuth extends Component {
    static displayName = wrapDisplayName(WrappedComponent, NAME);
    static propTypes = {
      isPrivate: PropTypes.bool,
      isAuthenticated: PropTypes.bool,
      __isMemberAreaActive: PropTypes.bool,
      __isSite: PropTypes.bool,
    };

    forPublicUser = (fn, options) => {
      if (!this.props.__isMemberAreaActive || !this.props.__isSite) {
        return fn;
      }
      return this.decorateWithPrivacyChecker(fn, options);
    };

    decorateWithPrivacyChecker = (fn, { preventDefault = false } = {}) => {
      const isPrivate = () => this.props.isPrivate;
      const isAuthenticated = () => this.props.isAuthenticated;

      return function (...args) {
        if (preventDefault) {
          const event = args[0];
          event.preventDefault && event.preventDefault();
        }

        if (isAuthenticated() && isPrivate()) {
          showJoinCommunityPopup(hasJoined => hasJoined && fn.apply(this, args));
        } else {
          return fn.apply(this, args);
        }
      };
    };

    render() {
      const props = omit(
        { forPublicUser: this.forPublicUser, ...this.props },
        ['__isMemberAreaActive', '__isSite']
      );
      return <WrappedComponent {...props}/>;
    }
  }

  hoistNonReactStatics(WithAuth, WrappedComponent);

  return flowRight(connect(mapStateToProps))(WithAuth);
}


function mapStateToProps(state) {
  return {
    currentUser: getCurrentUser(state),
    isAuthenticated: state.auth.isAuthenticated,
    isBlocked: isBlocked(state),
    isOwner: isOwner(state),
    isPrivate: isPrivate(state),
    __isMemberAreaActive: isMemberAreaActive(state),
    __isSite: isSite(state),
  };
}



// WEBPACK FOOTER //
// ./app/hoc/with-auth.js